const Miscellaneous={
    'EmptyProjectThumbnail':"https://firebasestorage.googleapis.com/v0/b/poc-project-309214.appspot.com/o/static%2Fempty-project-thumbnail.png?alt=media&token=426cba4f-b8c6-401c-b3d3-b20f2f6a6e1e",
    'OnboardingZoomCallUrl': "https://zoom.us/j/9144863684?pwd=M29PZWRqZ1M3VUUxSDVJMmZTZ0RzUT09"
}

export default Miscellaneous;